export default "__VITE_ASSET__BiR5GTKg__"